// BEGIN VENDOR ASSETS
// import { Fancybox } from '@fancyapps/ui'
import 'slick-carousel'
// END VENDOR ASSETS

import './global.js'
import './components-equal.js'
import './components-linkselect.js'
import './components-anchors.js'

import './lazy-img.js'

// PAGE SCRIPTS
import './single-leasing-office.js'
// BEGIN INDIVIDUAL COMPONENT SCRIPTS
// NOTE: If your component does not need specific script functionality there
// there is no need to include the default scripts from the component starter
import '../../components/component-accordion/src/scripts/_base.js'
import '../../components/component-amenities/src/scripts/_base.js'
import '../../components/component-assetmap/src/scripts/_base.js'
import '../../components/component-blog/src/scripts/_base.js'
import '../../components/component-cards/src/scripts/_base.js'
import '../../components/component-contact/src/scripts/_base.js'
import '../../components/component-contentblock/src/scripts/_base.js'
import '../../components/component-cookiebar/src/scripts/_base.js'
import '../../components/component-gallery/src/scripts/_base.js'
import '../../components/component-hero/src/scripts/_base.js'
import '../../components/component-hotspot/src/scripts/_base.js'
import '../../components/component-locationsmap/src/scripts/_base.js'
import '../../components/component-marketmap/src/scripts/_base.js'
import '../../components/component-pageintro/src/scripts/_base.js'
import '../../components/component-singlelocationmap/src/scripts/_base.js'
import '../../components/component-specials/src/scripts/_base.js'
import '../../components/component-splash/src/scripts/_base.js'
import '../../components/component-slider/src/scripts/_base.js'
import '../../components/component-team/src/scripts/_base.js'
import '../../components/component-timeline/src/scripts/_base.js'
import '../../components/component-videocallout/src/scripts/_base.js'
import '../../components/component-territorymap/src/scripts/_base.js'
// END INDIVIDUAL COMPONENT SCRIPTS

import './common.js'
import './emo.js'
